import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

// Route-level feature guard.
//
// Hiding a nav item (DashboardLayout's NAV_ITEMS filter) only removes the link —
// the route table in App.js registers every dashboard child unconditionally, so a
// typed or bookmarked URL still renders the page. Existing gated pages each carry
// their own redirect line (e.g. FinancesPage.js), but Check-ins and Classroom
// never got one, so they were reachable by direct URL with the feature off.
//
// Wrapping the route does it once, in the place that already knows the mapping,
// and sidesteps the "guard must run after the hooks" ordering trap that a
// per-component early return creates.
//
// `studio` is null while /auth/me is in flight — don't redirect then, or a page
// refresh bounces the user to Overview before their features have loaded.
export default function FeatureRoute({ feature, children }) {
  const { studio } = useAuth();

  if (studio && !studio.features?.[feature]) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
